import React from 'react';
import {Link} from 'react-router-dom';
// imgs
import pic1 from '../imgs/1.jpg';
import banner_bg from '../imgs/banner-bg.jpg';
import banner_bg_2 from '../imgs/banner-bg-2.jpg';

// seed
import {properties} from '../seed/data';

class Discover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      q: '',
      showSug: false
    }
    this.searchRef = React.createRef();
  }
  onHandleType (e) {
    this.setState({q: e.target.value, showSug: e.target.value !== ''})
  }
  onHandleClickSug (e) {
    this.setState({q: e.target.text, showSug: false});
    this.searchRef.current.focus();
  }
  onHandleKeydown (e) {
    if (e.keyCode == 13) {
      this.props.history.push(`/search?q=${this.state.q}`)
    }
  }
  renderProperties () {
    return properties.map((p, i) => (
      <div className="col-6 col-sm-6 col-md-4 col-lg-3" key={i}>
              <Link to={`/property/${i}`} className="card-link">
                <div className="property-listing-item">
                  <div className="property-listing-item-img">
                    <img src={p.img}/>
                  </div>
                  <div className="property-listing-item-info">
                    <div className="property-listing-item-info-major">{p.address}</div>
                    <div className="property-listing-item-info-minor flex-space-between">
                      <span>{p.room_count} Rm avail.</span>
                      <span>${p.price}/Rm</span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
    ))
  }
  render() {
    let params = new URLSearchParams(this.props.history.location.search);
    let isLogout = params.get("logout");
    let isLogin = params.get("login");
    return (
      <div className="container frame">
        {/* SYSTEM MESSAGE */}
        {isLogout ? (
          <div className="alert alert-success" role="alert">
            You have logged out!
          </div>
        ) : null}
        {isLogin ? (
          <div className="alert alert-success" role="alert">
            Welcome back!
          </div>
        ) : null}
        {/* BANNER */}
        <div className="banner">
          <h1 className="banner-title">Find a room. Be independent.</h1>
          <div className="banner-content">
            <div className="banner-search">
              <input type="text" className="form-control" 
                placeholder="Search location"
                value={this.state.q}
                onKeyDown={this.onHandleKeydown.bind(this)}
                onChange={this.onHandleType.bind(this)}
                ref={this.searchRef}/>
                
                  <div className={this.state.showSug ? 
                    "dropdown-menu dropdown-show" : "dropdown-menu"}>
                    <a className="dropdown-item" href="#" autoFocus onClick={this.onHandleClickSug.bind(this)}>A</a>
                    <a className="dropdown-item" href="#" onClick={this.onHandleClickSug.bind(this)}>B</a>
                  </div>
                
            </div>
          </div>
        </div>
        
        {/*PROPERTY LISTING*/}
        <div className="row">
        <h4 className="section-title">Discover </h4>
        </div>
        <div className="row">
            {this.renderProperties()}
          </div>
      </div>
      )
  }
}

export default Discover;